import React, { useRef } from 'react'
import SlidingPane from "react-sliding-pane";
import Tooltip from "@tippyjs/react";
import "react-toastify/dist/ReactToastify.css";
import "tippy.js/dist/tippy.css";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { getTrans as t } from "../../../Localization/translations";
import Helper from '../../../Helper';

const AddPayment = ({ state5, setState5, setRowsData, setTermError, form6, handleSubmit6, handlePayment, addTableRows, rowsData, handlePaymentTypeChange, paymentType, handelChangeAmount,
  errors, handlePaymentFrequencyChange, paymentFrequency, handleTermChange, deleteTableRows, termError, checkBtn6
}) => {
  return (
    <SlidingPane
      className="some-custom-class sidepanebarcontract"
      // paneClassName="custom-pane-width"
      isOpen={state5.isPaneOpen}
      title="Add Payment Amount"
      subtitle=""
      onRequestClose={() => {
        setState5({ isPaneOpen: false });
        setRowsData([])
        setTermError("")
      }}
    >
      <Form
        role='form text-left'
        ref={form6}
        key={6}
        onSubmit={handleSubmit6(handlePayment)}
        method="POST"
        id="addAssetForm"
      >
        <>
          <div className="table-responsive-sm">
            <div className="row pt-3">
              <div className="col-xl-6">
                <label className="col-form-label">
                  {t("Payment Lines")}
                </label>
              </div>
              <div className="col-xl-6">
                <div className="text-right ">
                  <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={addTableRows}
                  >
                    + {t("ADD")}
                  </button>
                </div>
              </div>
            </div>
            <table
              id="invoice"
              className="table table-nowrap mb-0"
            >
              <thead>
                <th>
                  {t("Line no.")}{" "}
                  <Tooltip content={t("LineNumber_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
                <th>
                  {t("Payment Type")}{" "}
                  <Tooltip content={t("PaymentType_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
                <th>
                  {t("Amount")}{" "}
                  <Tooltip content={t("Amount_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
                <th>
                  {t("Payment Frequency")}{" "}
                  <Tooltip content={t("PaymentType_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
                <th>
                  {t("Total Terms")}{" "}
                  <Tooltip content={t("Totalterm_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
                <th>
                  {t("Date From")}{" "}
                  <Tooltip content={t("Datefrom_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
                <th>
                  {t("Date To")}{" "}
                  <Tooltip content={t("Dateto_Tooltip")}>
                    <i className="fa fa-light fa-circle-info"></i>
                  </Tooltip>
                </th>
              </thead>
              <tbody>
                {rowsData.map((data, index) => (
                  <tr key={index}>
                    <td
                      style={{ width: '50px', fontSize: '12px' }}
                    >
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Line no.")} {" "} <Tooltip content={t("LineNumber_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip></div>
                      <div>
                        {index + 1}
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}
                        {" "} <Tooltip content={t("PaymentType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>

                        <select
                          typeof="text"
                          className="form-control"
                          value={data.payment_type}
                          onChange={(evnt) =>
                            handlePaymentTypeChange(index, evnt.target.value)
                          }
                          name="payment_type"

                        >
                          {/* <option value='Rent'>Rent</option>
                               {paymentType.map((key, i) => (
                                 <option
                                   key={i}
                                   value={key.fee_name}
                                 >
                                   {key.fee_name}
                                 </option>
                               ))} */}
                          <option value='Rent'>Rent</option>
                          {paymentType.map((key, i) => (
                            <option
                              key={i}
                              value={key.value}
                            >
                              {key.label}
                            </option>
                          ))}

                        </select>
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Amount")}
                        {" "} <Tooltip content={t("Amount_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <input
                          type="text"
                          placeholder="amount"
                          value={data.amount}
                          onChange={(evnt) => handelChangeAmount(index, evnt.target.value)}
                          name="termItem"
                          className="form-control"
                          style={{ width: '80px', fontSize: '12px' }}
                        />
                        <div className="invalid-feedback">
                          {errors.amount &&
                            "Amount is required"}
                        </div>
                      </div>

                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Payment Type")}
                        {" "} <Tooltip content={t("PaymentType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        <select
                          className="form-control"
                          value={data.payment_frequency}
                          disabled={
                            data.payment_type === 'Rent' ||
                            data.payment_type === 'Origination Fee' ||
                            data.payment_type === 'Documentation Fee'
                          }
                          onChange={(evnt) => handlePaymentFrequencyChange(index, evnt.target.value)}
                          name="payment_frequency"
                        >
                          {paymentFrequency.map((key, i) => (
                            <option
                              key={i}
                              value={key.label}
                            >
                              {key.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Total Terms")}
                        {" "}<Tooltip content={t("Totalterm_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>
                        {/* <input
                          type="text"
                          placeholder="Term"
                          value={data.payment_type === 'Origination Fee' || data.payment_type === 'Documentation Fee'
                            ? 1 : data.no_of_payments}
                          onChange={(evnt) => handleTermChange(index, evnt.target.value)}
                          name="termItem"
                          className="form-control"
                          disabled={data.payment_type === 'Origination Fee' || data.payment_type === 'Documentation Fee'}
                          style={{ width: '80px', fontSize: '12px' }}
                        /> */}
                        <input
                          type="text"
                          placeholder="Term"
                          value={paymentType.find(pt => pt.value === data.payment_type)?.fee_nature === 'One Time' ? 1 : data.no_of_payments}
                          onChange={(evnt) => handleTermChange(index, evnt.target.value)}
                          name="termItem"
                          className="form-control"
                          disabled={paymentType.find(pt => pt.value === data.payment_type)?.fee_nature === 'One Time'}
                          style={{ width: '80px', fontSize: '12px' }}
                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Date From")}
                        {" "}<Tooltip content={t("Datefrom_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>

                        <input
                          disabled
                          type="text"
                          className="form-control"
                          name="date_from"
                          id="payment_enddate"
                          value={Helper.Dateview(data.start_date)}
                          style={{ width: '80px', fontSize: '12px' }}

                        />
                      </div>
                    </td>
                    <td>
                      <div className="d-xl-none tc d-md-none d-lg-none">{t("Date To")}
                        {" "} <Tooltip content={t("Dateto_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </div>
                      <div>

                        <input
                          disabled
                          type="text"
                          className="form-control"
                          name="date_to"
                          id="payment_enddate"
                          value={Helper.Dateview(data.end_date)}
                          style={{ width: '80px', fontSize: '12px' }}
                        />
                      </div>
                    </td>

                    <td>
                      <button
                        className="btn btn-outline-danger "
                        onClick={() => deleteTableRows(index)}
                      >
                        x
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {termError && <div className="invalid-feedback">{termError}</div>}
          </div>
          <button
            type="submit"
            className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
          // disabled={disablebutton}
          >
            {t("Save")}
          </button>
        </>
        <CheckButton style={{ display: "none" }} ref={checkBtn6} />
      </Form>
    </SlidingPane>
  )
}

export default AddPayment